// @flow
import React from "react";
import { connect } from "react-redux";
import NoonNowBadgeEn from "../../../images/noon-now-en.svg";
import NoonNowBadgeAr from "../../../images/noon-now-ar.svg";
import sellerB2B from "../../../images/common/SellerB2B.svg";
import sellerB2BAr from "../../../images/common/sellerB2B-ar.svg";
import styles from "./Badge.scss";

const Badge = props => {
  const image = props.sellerB2B
    ? props.locale.lang === "en" ? sellerB2B : sellerB2BAr
    : props.locale.lang === "en" ? NoonNowBadgeEn : NoonNowBadgeAr;
  return (
    <div className={styles.noonNowBadge}>
      <img src={image} alt="badgeImage" />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    locale: state.locale
  };
};

export default connect(mapStateToProps)(Badge);



// WEBPACK FOOTER //
// ./src/components/common/badge/Badge.js